import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';

import { MoneticoPaymentInfo } from '../../../models/monetico-payment-info';
import { PaymentService } from '../../../services/payment.service';
import { Payment } from '../../../models/payment';

@Component({
  selector: 'app-monetico-payment',
  templateUrl: './monetico-payment.component.html',
  styleUrls: ['./monetico-payment.component.css']
})
export class MoneticoPaymentComponent implements OnInit {
  @Input() chamberId: string;
  @Input() paymentToken: string;
  @Output() paymentError: EventEmitter<any> = new EventEmitter();

  moneticoPaymentInfo: MoneticoPaymentInfo;
  loading: boolean;

  constructor(private paymentService: PaymentService, private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.loading = false;
    this.moneticoPaymentInfo = new MoneticoPaymentInfo();
  }

  initiatePayment(hiddenMoneticoForm: any) {
    this.loading = true;
    this.paymentService.getPayment(this.paymentToken, this.chamberId)
    .then((payment: Payment) => {
      this.moneticoPaymentInfo = payment.MoneticoPayment;
      this.cdr.detectChanges();
      hiddenMoneticoForm.submit();
      this.loading = false;
    })
    .catch((error) => {
      this.loading = false;
      this.paymentError.emit(error);
    });
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/components/payment/monetico-payment/monetico-payment.component.ts